export default __webpack_public_path__ + "static/media/Robofriends.79bec788.png";